import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng-fe/ui_pc_ad';

import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * 定义 Footer 组件
 */
class RightGroup extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        // event: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <ul className={styles.news_list}>
                {content.map(
                    (item, index) =>
                        (
                            <li className={styles.no_image} key={index}>
                                <a href={item.url} title={item.title} target="_blank" rel="noreferrer">
                                    {item.title}{' '}
                                </a>
                            </li>
                        )
                )}
            </ul>
        );
    }
}

export default errorBoundary(RightGroup);
